import React from 'react';
import {
  List,
  DataTable,
  TextInput,
  SelectInput,
  FilterForm,
  DateField,
} from 'react-admin';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

import { useTitle } from '@src/hooks/useTitle';

import type { ShopifyProductRedirect } from './types';

const STATUS_CHOICES = [
  { id: 'active', name: 'Active' },
  { id: 'deleted', name: 'Deleted' },
  { id: 'failed', name: 'Failed' },
];

const statusColor = (status: string | null | undefined): 'success' | 'error' | 'warning' | 'default' => {
  switch (status) {
    case 'active':
      return 'success';
    case 'deleted':
      return 'error';
    case 'failed':
      return 'warning';
    default:
      return 'default';
  }
};

const filters = [
  <TextInput key="q" source="q" label="Search handles or product ID" alwaysOn />,
  <SelectInput key="status" source="status" label="Status" choices={STATUS_CHOICES} alwaysOn />,
];

const ShopifyRedirectsList = () => {
  const { title } = useTitle('Shopify Redirects');

  return (
    <List
      perPage={50}
      sort={{ field: 'id', order: 'DESC' }}
      title={title}
    >
      <Box sx={{ px: 2, pt: 1 }}>
        <FilterForm filters={filters} />
      </Box>
      <DataTable rowClick="show" bulkActionButtons={false}>
        <DataTable.Col source="fromHandle" label="From Handle" />
        <DataTable.Col source="toHandle" label="Original Target" />
        <DataTable.Col source="currentTarget" label="Resolved Target" />
        <DataTable.Col
          source="status"
          label="Status"
          render={(record: ShopifyProductRedirect) => (
            <Chip
              label={record.status ?? 'unknown'}
              color={statusColor(record.status)}
              size="small"
            />
          )}
        />
        <DataTable.Col
          source="catalogItem"
          label="Catalog Item"
          disableSort
          render={(record: ShopifyProductRedirect) => {
            const item = record.catalogItem;
            if (!item) return <em style={{ color: '#888' }}>—</em>;
            return item.title ?? item.sku ?? `#${item.id}`;
          }}
        />
        <DataTable.Col
          source="createdAt"
          label="Created"
          render={(record: ShopifyProductRedirect) => (
            <DateField record={record} source="createdAt" />
          )}
        />
      </DataTable>
    </List>
  );
};

export default ShopifyRedirectsList;
